// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"75c5e5ce","259":"3f9cdd5d","304":"d2f97aee","346":"27a2f3e1","409":"a21647c9","415":"fa73aaa0","482":"5710e01f","658":"e813d204","837":"19aef5c6","906":"6e4ede82","940":"d41867f5"}[chunkId] + ".chunk.js";
};